define([], function () {
    var framework = {
        "fpwd.emailVerifyCode": "Verification Code",
        "fpwd.getCode": "Send Code",
        accountNameBlank: "The account name cannot be left blank."
    };
    function i18n(key) {
        return i18n.framework[key];
    };
    i18n.framework = framework;
    return i18n;
})


// WEBPACK FOOTER //
// ./public/hws/i18n/en-us/resourcehk.js